"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericMapLine = void 0;
const theme_1 = require("../../../components/theme");
const mithril_1 = require("../../../mithril");
const CSS = {
    line: 'c-GenericMapLine',
};
const Style = {
    [CSS.line]: {
        position: 'absolute',
        strokeWidth: '2px',
        fill: 'none',
        pointerEvents: 'none',
    },
};
(0, theme_1.addStyles)(Style);
exports.GenericMapLine = {
    view({ key, start, end, color, strokeWidth = '2px', onClick, additionalClasses, additionalStyles, }) {
        // Pad the SVG by the stroke width so lines along an axis (0px width or height) remain visible
        const pad = parseFloat(strokeWidth) || 2;
        const minX = Math.min(start.x, end.x) - pad;
        const minY = Math.min(start.y, end.y) - pad;
        const width = Math.abs(end.x - start.x) + pad * 2;
        const height = Math.abs(end.y - start.y) + pad * 2;
        return (0, mithril_1.m)('svg', {
            key,
            className: CSS.line,
            style: Object.assign({ left: `${minX}px`, top: `${minY}px`, width: `${width}px`, height: `${height}px` }, additionalStyles),
        }, [
            (0, mithril_1.m)('line', {
                x1: start.x - minX,
                y1: start.y - minY,
                x2: end.x - minX,
                y2: end.y - minY,
                stroke: color,
                'stroke-width': strokeWidth,
                onclick: onClick,
                style: {
                    pointerEvents: onClick ? 'auto' : 'none',
                    cursor: onClick ? 'pointer' : 'default',
                },
            }),
        ]);
    },
};
//# sourceMappingURL=map.line.generic.js.map